import React from 'react';

const Users = () => {
  return (
    <>
      <div class="container d-flex flex-column justify-content-center align-items-center">
        <h2>Users Page: This is Private Route</h2>
      </div>
    </>
  );
};

export default Users;
